import axios from 'axios';
import { navigateTo } from '../router/navigation';

export const BaseURL = process.env.REACT_APP_ENV === 'local' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;
// axios base to use for all requests
const axiosBase = axios.create({

  baseURL: BaseURL,
  timeout: 30000,
  headers: {
    'Accept': 'application/json',
  },
});

axiosBase.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      navigateTo('/login', { replace: true });
    }
    return Promise.reject(error);
  }
);

// axios GET request
export const get = (url, params) => {
  if (localStorage.getItem('token')) {
    return axiosBase.get(url, {
      params: params,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}

// axios POST request
export const post = (url, data) => {
  if (localStorage.getItem('token')) {
    return axiosBase.post(url, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}

export const postData = (url, data) => {
  if (localStorage.getItem('token')) {
    return axiosBase.post(url, data, {
      timeout: 120000,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}

export const auth = (url, data) => {
  return axiosBase.post(url, data);
}

// axios PUT request
export const put = (url, data) => {
  if (localStorage.getItem('token')) {
    return axiosBase.put(url, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}

export const putData = (url, data) => {
  if (localStorage.getItem('token')) {
    return axiosBase.put(url, data, {
      timeout: 120000,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}

// axios DELETE request
export const remove = (url) => {
  if (localStorage.getItem('token')) {
    return axiosBase.delete(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });
  } else {
    navigateTo('/login', { replace: true });
    return Promise.reject(new Error('Missing auth token'));
  }
}
